import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

var Api = environment.Api;


@Injectable({
  providedIn: 'root'
})
export class DiagnosticserviceService {

  constructor(private http: HttpClient) { }

  adddiagnostics(data) {
    return this.http.post<any>(Api + `adddiagnostics`, data).pipe(map(res => {
      return res;
    }, error => {
      return error;
    }));
  }

  getdiagnostics() {
    var data = {
      company_id: localStorage.getItem('company_id')
    }
    return this.http.post<any>(Api + `getdiagnostics`, data).pipe(map(res => {
      return res;
    }, error => {
      return error;
    }));
  }

  editdiagnostics(data) {
    return this.http.post<any>(Api + `editdiagnostics`, data).pipe(map(res => {
      return res;
    }, error => {
      return error;
    }));
  }

  deletediagnostics(data) {
    return this.http.post<any>(Api + `deletediagnostics`, data).pipe(map(res => {
      return res;
    }, error => {
      return error;
    }));
  }

  getappointments() {
    var data = {
      company_id: localStorage.getItem("company_id"),
    };
    return this.http.post<any>(Api + `getappointments`, data).pipe(
      map(
        (res) => {
          return res;
        },
        (error) => {
          return error;
        }
      )
    );
  }

  assigndiagnostics(data) {
    console.log('Data sent to backend:', data);
    return this.http.post<any>(Api + `assigndiagnostics`, data).pipe(map(res => {
      return res;
    }, error => {
      return error;
    }));
  }

  getassigndiagnostics() {
    var data = {
      company_id: localStorage.getItem('company_id')
    }
    return this.http.post<any>(Api + `getassigndiagnostics`, data).pipe(map(res => {
      return res;
    }, error => {
      return error;
    }));
  }

  editasssigndiagnostics(data) {
    return this.http.post<any>(Api + `editasssigndiagnostics`, data).pipe(map(res => {
      return res;
    }, error => {
      return error;
    }));
  }

  deleteassigndiagnostics(data) {
    return this.http.post<any>(Api + `deleteassigndiagnostics`, data).pipe(map(res => {
      return res;
    }, error => {
      return error;
    }));
  }

  gettestlist(data) {
    return this.http.post<any>(Api + `gettestlist`, data).pipe(map(res => {
      console.log("service:", data);
      
      return res;
    }, error => {
      return error;
    }));
  }
}
